import styled from "styled-components";

const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`;

const DismissableContent = styled.div`
  position: relative;
`;

CloseButtonWrapper.displayName = "CloseButtonWrapper";
DismissableContent.displayName = "DismissableContent";

export { CloseButtonWrapper, DismissableContent };
